export default "__VITE_ASSET__49b6033e__"